import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SubscribedContainer } from '../../../util/subscribed-container';
import { CustomerService } from '../../../../../services/customer.service';
import { TranslateService } from '@ngx-translate/core';
import { IGenericBaryFormGroup } from '../../../../../models/forms/GenericBaryFormGroup';
import { BaryModalService } from '../../../../../services/bary-modal.service';

export type MiddleUserForcedActivationControls = {
  userForcedActivation: FormControl;
};

@Component({
  selector: 'jhi-user-forced-activation-card',
  templateUrl: './user-forced-activation-card.component.html',
  styleUrls: ['./user-forced-activation-card.component.scss'],
})
export class UserForcedActivationCardComponent extends SubscribedContainer implements OnInit {
  @Input() userForcedActivationForm!: IGenericBaryFormGroup<MiddleUserForcedActivationControls>;
  @Input() baryForm!: FormGroup;
  @Input() editable = true;
  @Input() switchButton = false;
  @Input() description?: string;
  @Output() saveEvent = new EventEmitter();
  @Output() switchChangeEvent = new EventEmitter();
  private rollbackCompany!: FormGroup;
  public switchUserForcedActived = false;

  constructor(protected customerService: CustomerService, protected baryModalService: BaryModalService, protected translateService: TranslateService) {
    super();
  }

  ngOnInit(): void {
    if (!this.editable) {
      this.userForcedActivationForm.getAngularForm().disable();
    }
  }

  get companyForm(): FormGroup {
    return this.baryForm.get('companyForm') as FormGroup;
  }

  switchEdit(): void {
    this.editable = !this.editable;
    if (!this.editable) {
      this.companyForm.disable();
    } else {
      this.companyForm.enable();
    }
  }

  cancel(): void {
    this.companyForm.setValue(this.rollbackCompany);
    this.switchEdit();
  }

  save(): void {
    if (this.companyForm.invalid) {
      this.companyForm.markAllAsTouched();
    } else {
      this.saveEvent.emit(this.companyForm.value);
      this.switchEdit();
    }
  }

  userForcedActived(): void {
    const message = this.translateService.instant('baryApp.customer.confirm.userForcedActived');
    this.baryModalService
      .openConfirm(message)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.switchUserForcedActived = true;
          this.userForcedActivationForm.controls.userForcedActivation.setValue(true);
          this.saveEvent.emit(this.userForcedActivationForm.getAngularForm().value);
        } else {
          this.switchUserForcedActived = false;
        }
      });
  }
}
